var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-list"},[_c('bs-table',{attrs:{"routeWatch":true,"props":{height:this.$store.getters.tableHeight,view:this.$route.query._view||'table'},"class-name":"console","route":_vm.route}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }